import Header from "../../components/public/header";
import Navigation from "../../components/public/navigation";
import Main from "../../components/public/sections/main";
import ContactUs from "../../components/public/contactus";
import Footer from "../../components/public/footer";

export default () => {
  return (
    <>
      <Navigation />
      <Header />
      <Main pageHeading={"संपर्क"} content={<ContactUs />} />
      <Footer />
    </>
  );
};
